export enum IdTypeContent {
  Atto = '1',
  Annotazione = '2',
  Trascrizione = '3',
  AnnotazioneAutomatica = '4',
  Rifiuto = '5',
  AttiETrascrizione = 'AT',
}

export const getNameTypeContent = (id?: string): string => {
  if (!id) {
    return '';
  }

  switch (id) {
    case IdTypeContent.Atto:
      return 'ATTO';
    case IdTypeContent.Annotazione:
      return 'ANNOTAZIONE';
    case IdTypeContent.Trascrizione:
      return 'TRASCRIZIONE';
    case IdTypeContent.AnnotazioneAutomatica:
      return 'ANNOTAZIONE AUTOMATICA';
    case IdTypeContent.Rifiuto:
      return 'RIFIUTO';
    case IdTypeContent.AttiETrascrizione:
      return 'ATTI E TRASCRIZIONI';
    default:
      return id;
  }
};
